import { FusaReply } from "@/types/replyTypes";
import { Client } from "./client";
  import { ValidationCreateResponse, ValidationResponse, ValidationUpdateRequest } from "@/backend/express/controllers/validationController";

export class ValidationController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  public async readValidation(id: string): Promise<ValidationResponse> {
    return this.client.read(`/api/validations/${id}`);
  }

  public async createValidation(parameterId: string): Promise<ValidationCreateResponse> {
    return this.client.create(`/api/validations/${parameterId}`, {});
  }

  public async createContainerValidation(containerId: string): Promise<ValidationCreateResponse> {
    return this.client.create(`/api/validations/container/${containerId}`, {});
  }

  public async updateValidation(request: ValidationUpdateRequest): Promise<ValidationResponse> {
    return this.client.update(`/api/validations`, request);
  }

  /** Asks for this validation to be run again, whatever its verdict says now. */
  public async prepareRun(id: string): Promise<ValidationResponse> {
    return this.client.create(`/api/validations/${id}/run`, {});
  }

  public async deleteValidation(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/validations/${id}`);
  }
}
